<template>
    <Dialog
        :is-popup="value"
        class="profile-popup"
        :class="{ 'profile-popup_success': successMessage }"
        @close="close"
        :has-close-button="successMessage"
        :padding="false"
    >
        <div v-if="successMessage" class="profile-popup__container">
            <div class="profile-popup__body profile-popup__body_success">
                <div>
                    <ProfileSuccessPopupIcon />
                </div>
                <div>Спасибо, нам это важно!</div>
            </div>
            <div class="profile-popup__footer profile-popup__footer_success">
                <div>
                    <button class="button button-blue" @click="close">ОК</button>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="profile-popup__header">
                <div>
                    <ProfilePopupIcon />
                </div>
                <div>
                    <strong>Уважаемый участник!</strong> Мы очень хотим уменьшить дублирование аккаунтов на платформе,
                    чтобы у тебя не возникало проблем при участии в наших проектах. Пожалуйста, заполни недостающие
                    данные о себе.
                </div>
            </div>
            <div class="profile-popup__body">
                <div class="profile-popup__body-caption">Необходимо заполнить данные</div>
                <div class="profile-popup__form">
                    <ModelString
                        id="data-request__surname"
                        label="Фамилия"
                        v-model="data.surname"
                        hidden-lenght-counter
                        :invalidateFunction="() => errors.surname"
                        :maxlength="100"
                    />
                    <ModelString
                        id="data-request__name"
                        label="Имя"
                        v-model="data.name"
                        hidden-lenght-counter
                        :invalidateFunction="() => errors.name"
                        :maxlength="100"
                    />
                    <ModelString
                        id="data-request__patronymic"
                        label="Отчество"
                        hidden-lenght-counter
                        :disabled="data.isPatronymic"
                        v-model="data.patronymic"
                        :invalidateFunction="() => errors.patronymic"
                        :maxlength="100"
                    />
                    <ModelCheckbox id="isUntilNow" label="Нет отчества" v-model="data.isPatronymic" textRight />
                    <div>
                        <ModelAddress
                            :class="{ 'has-error': errors.address }"
                            label="Город проживания"
                            v-model="data.address"
                        />
                        <div v-if="errors.address" class="mt-invalid-text">{{ errors.address }}</div>
                    </div>
                    <ModelISO
                        label=""
                        v-model="data.dateOfBirth"
                        year-input-type="select"
                        :max-year="currentYear"
                        :valid="!errors.dateOfBirth"
                        :validator="() => errors.dateOfBirth"
                    />
                    <div v-if="errors.error" class="mt-invalid-text">{{ errors.error }}</div>
                </div>
            </div>
            <div class="profile-popup__footer">
                <button class="button button-blue" @click="save">Сохранить</button>
            </div>
        </div>
    </Dialog>
</template>

<script>
import Dialog from '@/components/UI/Dialog.vue';
import ProfileSuccessPopupIcon from '@/components/UI/icons/ProfileSuccessPopupIcon.vue';
import ProfilePopupIcon from '@/components/UI/icons/ProfilePopupIcon.vue';
import ModelString from '@/components/UI/models/ModelString.vue';
import ModelCheckbox from '@/components/UI/models/ModelCheckbox.vue';
import ModelAddress from '@/components/UI/models/ModelAddress.vue';
import ModelISO from '@/components/UI/models/ModelISO.vue';
import { mapActions } from 'vuex';
import { checkName } from '@/tools/tools';

const actions = ['postProfileData'];
export default {
    name: 'ProfilePopup',
    components: {
        ModelAddress,
        ModelISO,
        ModelCheckbox,
        ModelString,
        ProfilePopupIcon,
        ProfileSuccessPopupIcon,
        Dialog,
    },
    props: {
        value: Boolean,
        profile: Object,
    },
    data: () => {
        const today = new Date();
        return {
            successMessage: false,
            currentYear: today.getFullYear() - 3,
            data: {
                surname: '',
                name: '',
                patronymic: '',
                isPatronymic: false,
                address: null,
                dateOfBirth: '',
            },
            dateOfBirth: 0,
            errors: {},
        };
    },
    watch: {
        'data.isPatronymic'() {
            if (this.data.isPatronymic) {
                this.data.patronymic = '';
            }
        },
    },
    beforeMount() {
        this.data.surname = this.profile.surname;
        this.data.name = this.profile.name;
        this.data.patronymic = this.profile.patronymic;
        this.data.isPatronymic = this.profile.isPatronymic;
        this.data.address = this.profile.address;
        this.data.dateOfBirth = this.profile.dateOfBirth;
        this.validate();
    },
    methods: {
        ...mapActions(actions),
        close() {
            document.location.reload();
        },
        isCity(address) {
            return !!address.data.city || !!address.data.settlement || !!address.data.region;
        },
        validate() {
            this.errors = {};
            let isRussian = false;

            if (!this.data.address || !this.isCity(this.data.address)) {
                this.errors.address = 'Введи город проживания';
            } else {
                if (this.data.address.data.country === 'Россия') {
                    isRussian = true;
                }
            }

            this.data.surname = (this.data.surname || '').trim().replace(/[ ]{2,}/g, ' ');
            if (!this.data.surname) {
                this.errors.surname = 'Введи фамилию';
            } else {
                const resp = checkName(this.data.surname, 'Фамилия', isRussian);
                if (resp !== '') {
                    this.errors.surname = resp;
                }
            }

            this.data.name = (this.data.name || '').trim().replace(/[ ]{2,}/g, ' ');
            if (!this.data.name) {
                this.errors.name = 'Введи имя';
            } else {
                const resp = checkName(this.data.name, 'Имя', isRussian);
                if (resp !== '') {
                    this.errors.name = resp;
                }
            }

            this.data.patronymic = (this.data.patronymic || '').trim().replace(/[ ]{2,}/g, ' ');
            if (this.data.patronymic === '') {
                if (!this.data.isPatronymic) {
                    this.errors.patronymic = 'Введи отчество';
                }
            } else {
                const resp = checkName(this.data.patronymic, 'Отчество', isRussian);
                if (resp !== '') {
                    this.errors.patronymic = resp;
                }
            }

            if (!this.data.dateOfBirth) {
                this.errors.dateOfBirth = 'Укажи дату рождения';
            }

            return Object.values(this.errors).filter(Boolean).length === 0;
        },
        async save() {
            if (this.validate()) {
                try {
                    const resp = await this.postProfileData(this.data);
                    if (resp.status === 'success') {
                        this.successMessage = true;
                    } else {
                        this.errors = {
                            error: resp.message,
                        };
                    }
                } catch (e) {
                    this.errors = {
                        error: 'Ошибка сохранения',
                    };
                }
            }
        },
        updateDateOfBirth(val) {
            const year = `${val}`.substring(0, 4);
            const month = `${val}`.substring(4, 6);
            const day = `${val}`.substring(6, 8);
            this.data.dateOfBirth = `${year}-${month}-${day}`;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/rem';
@import '../../styles/mrem';
@import '../../styles/buttons_v2.scss';

.profile-popup {
    padding: 0;
    text-align: center;
    display: block;
    align-items: center;
    justify-content: center;
    font-family: Montserrat, sans-serif;
    * {
        font-family: Montserrat, sans-serif;
    }

    @include on-desktop {
        padding: rem(44);
        overflow-y: auto;
    }
    &_success {
        display: flex;
    }
    :deep(.dialog) {
        max-width: 100%;
        max-height: 100%;
        padding: 0;
        display: inline-flex;
        border-radius: 0;
        min-height: 100vh;
        @include on-desktop {
            max-width: rem(600);
            height: auto;
            overflow-y: hidden;
            max-height: unset;
            min-height: auto;
            border-radius: rem(20);
        }
        .close {
            box-shadow: none;
            border: 2px solid #2a2626;
            color: #2a2626;
        }
    }
    &__container {
        display: flex;
        flex-direction: column;
        flex: 1;
        justify-content: center;
        @include on-desktop {
            width: rem(600);
        }
    }
    &__header {
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #ecf4fb;
        gap: mrem(16);
        padding: mrem(16) mrem(20);

        font-size: mrem(14);
        font-weight: 400;
        line-height: mrem(20);
        color: #4663ab;
        text-align: center;
        @include on-desktop {
            gap: rem(16);
            font-size: rem(14);
            line-height: rem(20);
            padding: rem(16) rem(40);
            flex-direction: row;
            border-radius: rem(16) rem(16) 0 0;
            text-align: left;
        }
        svg {
            width: mrem(100);
            height: mrem(100);
            @include on-desktop {
                width: rem(120);
                height: rem(120);
            }
        }
    }
    &__body {
        padding: 0 mrem(20);
        @include on-desktop {
            padding: 0 rem(90);
        }
        &-caption {
            text-align: center;
            font-weight: 600;
            font-size: mrem(18);
            line-height: mrem(24);
            padding: mrem(24) 0;
            @include on-desktop {
                font-size: rem(24);
                line-height: rem(32);
                padding: rem(24) 0;
            }
        }
        &_success {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: mrem(40) mrem(40) 0 mrem(40);
            font-size: mrem(18);
            font-weight: 600;
            line-height: mrem(24);

            @include on-desktop {
                padding: rem(40) rem(40) 0 rem(40);
                font-size: rem(24);
                font-weight: 700;
                line-height: rem(36);
            }
        }
    }
    &__form {
        display: flex;
        flex-direction: column;
        gap: mrem(16);
        @include on-desktop {
            gap: rem(16);
        }
        :deep(.mt-input) {
            margin: 0;
            padding: mrem(18) 0 mrem(6) !important;
            border: 0;
            border-radius: 0;
            border-bottom: solid 1px #98a0a9;
            height: auto;
            @include on-desktop {
                padding: rem(18) 0 rem(6) !important;
            }
            &.invalid {
                border-color: #db6c61;
                color: #2a2626 !important;
                &::placeholder {
                    color: #db6c61 !important;
                }
            }
            .mt-input__value {
                color: #2a2626;
                .invalid {
                    border-color: #db6c61;
                    &::placeholder {
                        color: #db6c61;
                    }
                }
            }
            &::placeholder {
                font-size: mrem(16);
                font-weight: 400;
                line-height: mrem(22);
                @include on-desktop {
                    font-size: rem(16);
                    line-height: rem(22);
                }
            }
            .label {
                padding: 0;
                left: 0;
                top: 0;
                font-size: mrem(12);
                font-weight: 500;
                line-height: mrem(16);
                @include on-desktop {
                    font-size: rem(12);
                    line-height: rem(16);
                }
                &.invalid {
                    color: #db6c61;
                }
                &.hold-place {
                    top: mrem(18);
                    font-size: mrem(16);
                    @include on-desktop {
                        top: rem(18);
                        font-size: rem(16);
                    }
                }
            }
        }
        .has-error {
            :deep(.label) {
                color: #db6c61 !important;
            }
            :deep(.mt-input) {
                border-color: #db6c61 !important;
            }
        }
        :deep(input) {
            font-family: Montserrat, sans-serif;
        }
        :deep(.data-model) {
            gap: mrem(16);
            @include on-desktop {
                gap: rem(16);
            }
        }
        :deep(.mt-input__select) {
            max-height: mrem(130);
            @include on-desktop {
                max-height: rem(130);
            }
        }
        :deep(.label--text) {
            color: #98a0a9;
        }
        :deep(.mt-invalid-text),
        :deep(.error-message) {
            margin-top: mrem(12);
            font-size: mrem(12);
            font-weight: 400;
            line-height: mrem(16);
            text-align: left;
            color: #db6c61;
            @include on-desktop {
                margin-top: rem(16);
                font-size: rem(12);
                line-height: rem(16);
                text-align: left;
            }
        }
    }
    &__footer {
        align-self: center;
        padding: 40px;
        text-align: center;
        button {
            margin: 0 auto;
            font-size: mrem(14);
            font-weight: 600;
            line-height: mrem(20);
            text-align: center;
            width: auto;
            padding: mrem(14) mrem(32);
            @include on-desktop {
                font-size: rem(14);
                line-height: rem(20);
                padding: rem(14) rem(32);
            }
        }

        &_success {
            padding-bottom: 76px;
        }
    }
}
</style>
